/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

import { createContext, useCallback, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationHandoffErrorContext = /*#__PURE__*/createContext({
  threadErrors: {},
  updateThreadErrors: () => {}
});
export const ConversationHandoffErrorContextProvider = ({
  children
}) => {
  const [threadErrors, setThreadErrors] = useState({});
  const updateThreadErrors = useCallback((threadId, error) => setThreadErrors(prevThreads => Object.assign({}, prevThreads, {
    [threadId]: error
  })), []);
  const value = useMemo(() => ({
    threadErrors,
    updateThreadErrors
  }), [threadErrors, updateThreadErrors]);
  return /*#__PURE__*/_jsx(ConversationHandoffErrorContext.Provider, {
    value: value,
    children: children
  });
};